export function detectProvider(username?: string): 'Google' | 'LinkedIn' | 'email' {
  if (!username) return 'email';
  const lower = username.toLowerCase();
  if (lower.startsWith('google_')) return 'Google';
  if (lower.startsWith('linkedin_')) return 'LinkedIn';
  return 'email';
}
